// Vue 2 版本的状态管理 - 使用 Vue.observable
import Vue from 'vue'
import { DEFAULT_COMMUNITY } from '../utils/communityConfig'

const state = Vue.observable({
  currentCommunity: DEFAULT_COMMUNITY
})

export const communityStore = {
  get currentCommunity() {
    return state.currentCommunity
  },
  setCurrentCommunity(name) {
    state.currentCommunity = name
  }
}





